var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 582"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#8C8C76",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M7.5 4.5V10.5",
    stroke: "#8C8C76",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M10.5 7.5L4.5 7.5",
    stroke: "#8C8C76",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBadge);
export default __webpack_public_path__ + "static/media/add-badge.8af3c34985157a95b791a9f12a860b7c.svg";
export { ForwardRef as ReactComponent };